var map = {
	"./Auth/menu.js": "f517",
	"./CMS/menu.js": "ba13",
	"./Campaigns/menu.js": "e64f",
	"./Customers/menu.js": "c113",
	"./Dashboard/menu.js": "f2f0",
	"./Orders/menu.js": "421c",
	"./Products/menu.js": "39e4",
	"./Rules/menu.js": "d55d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "144b";